import React from "react";

export default function OtpInputs({ value, onChange, disabled, idPrefix = "agent-otp" }) {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 6).padEnd(6, " ").split("");

  function focusBox(index) {
    document.getElementById(`${idPrefix}-${index}`)?.focus();
  }

  function handleChange(index, nextValue) {
    const cleaned = String(nextValue || "").replace(/\D/g, "");
    if (cleaned.length > 1) {
      onChange(cleaned.slice(0, 6));
      focusBox(Math.min(cleaned.length, 5));
      return;
    }
    if (cleaned && !/^\d$/.test(cleaned)) {
      return;
    }
    const next = `${String(value || "").slice(0, index)}${cleaned}${String(value || "").slice(index + 1)}`.replace(/\D/g, "").slice(0, 6);
    onChange(next);
    if (cleaned && index < 5) {
      focusBox(index + 1);
    }
  }

  function handleKeyDown(index, event) {
    if (event.key === "Backspace" && !digits[index].trim() && index > 0) {
      onChange(String(value || "").slice(0, index - 1));
      focusBox(index - 1);
    }
  }

  function handlePaste(event) {
    event.preventDefault();
    const pasted = String(event.clipboardData.getData("text") || "").replace(/\D/g, "").slice(0, 6);
    onChange(pasted);
    focusBox(Math.min(Math.max(pasted.length, 1), 6) - 1);
  }

  return (
    <div className="agent-otp-row">
      {digits.map((digit, index) => (
        <input
          key={index}
          id={`${idPrefix}-${index}`}
          type="text"
          inputMode="numeric"
          autoComplete={index === 0 ? "one-time-code" : "off"}
          maxLength={1}
          className={`agent-otp-input${digit.trim() ? " is-filled" : ""}`}
          value={digit.trim()}
          disabled={disabled}
          onChange={(event) => handleChange(index, event.target.value)}
          onKeyDown={(event) => handleKeyDown(index, event)}
          onPaste={handlePaste}
          aria-label={`OTP digit ${index + 1}`}
        />
      ))}
    </div>
  );
}
